/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const greenApiWebhookTextMessageDataRequestSchema = z.object({
	textMessage: z.string().min(1),
});
